document.addEventListener("DOMContentLoaded", () => {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        console.warn("GSAP or one of its required plugins (ScrollTrigger/SplitText) is missing for the tagline section.");
        return;
    }

    gsap.registerPlugin(ScrollTrigger)
    ScrollTrigger.normalizeScroll(false);
    ScrollTrigger.config({ ignoreMobileResize: true });
});
